import {Modal as BootstrapModal, ModalFooter, ModalBody, ModalHeader} from 'reactstrap'
import {toastr} from 'react-redux-toastr'

import Loader from '../../../../shared/components/Loader/Loader.jsx'
import Modal from '../../../../shared/components//Modals/Modal.jsx'

import api from '../../../../api.js'

export default class DeleteAllMissionsModal extends Modal {
  constructor(props) {
    super(props)
    this.state = { loading: false }
  }

  delete = async () => {
    if (!this.props.experiences?.length) {
      toastr.info('Aucune expérience à supprimer.')
      return
    }

    this.setState({ loading: true })

    try {
      const deletePromises = this.props.experiences.map(exp =>
        api.freelances.experiences.delete({
          freelance: this.props.freelance.id,
          experience: exp.id
        })
      )

      await Promise.all(deletePromises)

      if (this.props.onClose) {
        this.props.onClose([])
      }

      toastr.success('Toutes les missions ont été supprimées avec succès.')
    } catch (error) {
      console.error(error)
      toastr.error('Erreur lors de la suppression des missions.')
    } finally {
      this.setState({ loading: false })
      this.props.closeModal()
    }
  }

  render() {
    if (!this.props.freelance) {
      return null
    }

    return (
      <BootstrapModal toggle={this.props.closeModal} isOpen={this.props.isOpen} className="mission-modal modal-lg">
        <ModalHeader toggle={this.props.closeModal}>Suppression</ModalHeader>
        <ModalBody>
          <div className="text-center">
            Vous êtes sur le point de supprimer toutes les expériences.
            Cette action est irreversible.
          </div>
          <Loader visible={this.state.loading}>
            Suppression...
          </Loader>
        </ModalBody>
        <ModalFooter>
          <button onClick={this.props.closeModal} type="button" className="btn btn-outline-shy">Annuler</button>
          <button onClick={this.delete} type="button" className="ml-auto btn btn-danger">Supprimer</button>
        </ModalFooter>
      </BootstrapModal>
    )
  }
}
